import { render, staticRenderFns } from "./OrgSwitchLoadingScreen.vue?vue&type=template&id=7b3c0fd8&scoped=true"
import script from "./OrgSwitchLoadingScreen.vue?vue&type=script&lang=js"
export * from "./OrgSwitchLoadingScreen.vue?vue&type=script&lang=js"
import style0 from "./OrgSwitchLoadingScreen.vue?vue&type=style&index=0&id=7b3c0fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c0fd8",
  null
  
)

export default component.exports